import { Injectable } from '@angular/core';
import { NgRedux } from '@ptl/angular-redux-store';
import { StateStructure, REDUCER_TYPES, Action } from '@ptl/state';

@Injectable({
  providedIn: 'root'
})
export class ReducerUtilityService {
  constructor(private ngRedux: NgRedux<StateStructure>) {
    /** When we are passing callbacks, sometiems the scope is lost, here */
    this.getPayloadStates = this.getPayloadStates.bind(this);
    this.getComponentStates = this.getComponentStates.bind(this);
  }

  /** GLOBAL COMPONENT STATES */
  getComponentStates(): any {
    const curState: StateStructure = this.ngRedux.getState();
    if (curState) {
      const stateAsGameState = curState.componentStates;
      return stateAsGameState;
    }
  }

  /** GLOBAL APPLICATION STATES */
  getApplicationStates(): any {
    const curState: StateStructure = this.ngRedux.getState();
    if (curState) {
      const stateAsGameState = curState.appStates;
      return stateAsGameState;
    }
  }

  /** GLOBAL PAYLOAD STATES */
  getPayloadStates(): any {
    const curState: StateStructure = this.ngRedux.getState();
    if (curState) {
      const stateAsGameState = curState.payloadStates;
      return stateAsGameState;
    }
  }

  /**
   * @Description Returns COMPONENT STATE objects.
   * @param reducerName - Matches the reducer name (aka state attribute) to be returned
   */
  getState<T>(reducerName: string): T {
    let componentStates = this.getComponentStates();

    if (componentStates && componentStates[reducerName]) {
      return componentStates[reducerName];
    } else {
      this.ngRedux.dispatch({ type: null });
      console.error(
        `Your requested state for [${reducerName}] is not setup. ` +
        `Please add your reducer to the ReducersRegistryModule`
      );
      /**
       * @TODO this doesn't do as we think - it should return an initialized state,
       * setTimeout does not delay the follow-up executions which rely on this
       */
      setTimeout(() => {
        componentStates = this.getComponentStates();
        return componentStates[reducerName];
      }, 0);
    }
  }

  /**
   * @Description Returns APPLICATION STATE objects.
   * @param reducerName - Matches the reducer name (aka state attribute) to be returned
   */
  getReducerFromApplicationState<T>(reducerName: string): T {
    const applicationStates = this.getApplicationStates();
    if (applicationStates && applicationStates[reducerName]) {
      return applicationStates[reducerName] as T;
    }
  }

  /**
   * Given a dot separated path, pulls data from payload states object
   * @param reducerName - dot-separated path
   */
  getPayloadState<T>(reducerName: string): T {
    return this.getStateFromPath(this.getPayloadStates(), reducerName) as T;
  }

  /**
   * Given a dot separated path, pulls data from payload states object
   * @param reducerName - dot-separated path
   */
  getGlobalStateItem<T>(reducerName: string): T {
    return this.getStateFromPath(this.ngRedux.getState(), reducerName) as T;
  }

  getStateFromPath(obj: any, dotSeparatedPath: string) {

    const getReducerValOrObj = (key: string, obj: any): any => {
      return obj[key];
    };

    const arr: string[] = dotSeparatedPath.split('.');

    for (let i = 0; i < arr.length; i++) {

      if (obj && (obj[arr[i]] || obj[arr[i]] === false)) {
        if (i === arr.length - 1) {
          return obj[arr[i]];
        } else {
          obj = getReducerValOrObj(arr[i], obj);
        }
      } else {
        // console.error(`${arr[i]} does not exist on `, obj);
        return null;
      }
    }
  }
}
